export default (title) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const formatted = new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const [day, month, year] = formatted.split(" ");
    return `${day} ${month}, ${year}`;
  };
  const colCount = title?.length;
  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return { colCount, gridStyle, formatDate };
};
